import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
// types
import type { SupportedLanguage } from "../../i18n/i18n";
import type { SelectInputChoice } from "../SelectInput/SelectInput";

const choices: SelectInputChoice<SupportedLanguage>[] = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
  { value: "ar", label: "عربي" },
  { value: "ru", label: "Русский" },
  { value: "uk", label: "Українська" },
  { value: "vi", label: "Tiếng Việt" },
  { value: "zh-CN", label: "中文（简体）" },
  { value: "fr-CA", label: "Français (Canada)" },
  { value: "so", label: "Soomaali" },
  { value: "hmn", label: "Hmoob" },
];

export const LanguageSelector = React.memo(() => {
  const {
    i18n: { changeLanguage, language },
  } = useTranslation();

  const handleLanguageChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      changeLanguage(event.target.value);
    },
    [changeLanguage],
  );

  return (
    <select
      className="mt-1 min-h-12 min-w-full rounded-xl border border-grey pl-1 focus:shadow-focus-glow"
      value={language}
      onChange={handleLanguageChange}
    >
      {choices.map((choice, idx) => {
        return (
          <option value={choice.value} key={idx}>
            {choice.label}
          </option>
        );
      })}
    </select>
  );
});

LanguageSelector.displayName = "LanguageSelector";
